import React from 'react';
import PropTypes from 'prop-types';
import mime from 'mime-types';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Button from '../Button';
import Box from '../Box';
import Embed from '../Embed';
import Grid from '../Grid';
import Modal from '../Modal';
import ModalContent from '../ModalContent';
import ModalHeader from '../ModalHeader';
import Heading from '../Heading';
import { StyledBrokenFileIcon, StyledFilePreviewAreaOuter } from './StyledFileViewer';
import { isString } from '../../utils/helpers';
var getFileName = function getFileName(file) {
  if (file.filename) {
    return file.filename;
  }
  if (file.url) {
    var name = file.url.substring(file.url.lastIndexOf('/') + 1);
    if (name.includes('?')) {
      var chuncks = name.split('?');
      return chuncks[0];
    }
    return name;
  }
  return '';
};
var getFileExtension = function getFileExtension(file) {
  var type = mime.lookup(getFileName(file));
  if (type) {
    return mime.extension(type);
  }
  if (file.type) {
    return mime.extension(file.type);
  }
  return 'unsupported';
};
var isImage = function isImage(file) {
  if (file && file.url && file.url.startsWith('data:image')) {
    return true;
  }
  var extension = getFileExtension(file);
  var extensions = ['jpg', 'jpeg', 'png', 'gif', 'svg'];
  return extensions.includes(extension);
};
function FileViewer(_ref) {
  var file = _ref.file,
    heading = _ref.heading,
    open = _ref.open,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(Modal, {
    open: open && file !== null,
    onClose: onClose,
    fullWidth: true
  }, file !== null && open && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalHeader, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h5"
  }, heading || getFileName(file))), /*#__PURE__*/React.createElement(ModalContent, null, /*#__PURE__*/React.createElement(StyledFilePreviewAreaOuter, null, function () {
    // display images as <img />...
    if (isImage(file)) {
      return /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        justifyContent: "center",
        width: "100%"
      }, /*#__PURE__*/React.createElement("img", {
        src: file.url,
        alt: getFileName(file),
        style: {
          maxWidth: '100%'
        }
      }));
    }
    // pdfs can be displayed by browser, but any other data URI cannot be previewed...
    if (file && isString(file.url) && file.url.startsWith('data') && getFileExtension(file) !== 'pdf' || getFileExtension(file) === 'unsupported') {
      return /*#__PURE__*/React.createElement(Grid, {
        container: true,
        spacing: 5,
        direction: "column",
        alignItems: "center",
        justify: "center"
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(StyledBrokenFileIcon, null, /*#__PURE__*/React.createElement(ErrorOutlineIcon, null))), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Heading, {
        as: "h5",
        transform: "uppercase"
      }, "Preview unavailable")), /*#__PURE__*/React.createElement(Grid, {
        item: true
      }, /*#__PURE__*/React.createElement(Button, {
        href: file.url,
        as: "a",
        download: true,
        color: "primary",
        size: "large"
      }, "Download")));
    }
    return /*#__PURE__*/React.createElement(Embed, {
      src: file.url.startsWith('data') || file.url.includes('.pdf') ? file.url : "https://docs.google.com/gview?url=" + file.url + "&embedded=true",
      height: "85%"
    });
  }()))));
}
FileViewer.propTypes = process.env.NODE_ENV !== "production" ? {
  file: PropTypes.shape({
    url: PropTypes.string,
    filename: PropTypes.string,
    type: PropTypes.string
  }),
  heading: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired
} : {};
FileViewer.defaultProps = {
  file: null,
  heading: '',
  open: false
};
export default FileViewer;